export const STEPS = [
  { id: 1, title: 'Student Info' },
  { id: 2, title: 'School Info' },
  { id: 3, title: 'Belonging' },
  { id: 4, title: 'Self-Regulation' },
  { id: 5, title: 'Literacy & Math' },
  { id: 6, title: 'Problem Solving' },
  { id: 7, title: 'ERS & Sign-Off' },
]

export const STEP_FIELDS = {
  1: [
    'studentName', 'oen', 'year', 'date',
    'daysAbsent', 'totalDaysAbsent', 'timesLate', 'totalTimesLate',
    'placement',
  ],
  2: [
    'teacher', 'earlyChildhoodEducator', 'principal', 'telephone',
    'board', 'school', 'schoolAddress', 'boardAddress',
    'frenchProgram',
  ],
  3: ['belongingEsl', 'belongingIep', 'belongingComments'],
  4: ['selfRegulationEsl', 'selfRegulationIep', 'selfRegulationComments'],
  5: ['literacyMathEsl', 'literacyMathIep', 'literacyMathComments'],
  6: ['problemSolvingEsl', 'problemSolvingIep', 'problemSolvingComments'],
  7: [
    'ersCompleted', 'ersDateYear', 'ersDateMonth', 'ersDateDay', 'ersBenchmarkMet',
    'eceNames',
  ],
}

export const FIELD_LABELS = {
  date: 'Date',
  studentName: 'Student Name',
  oen: 'OEN',
  year: 'Year (JK / SK)',
  daysAbsent: 'Days Absent',
  totalDaysAbsent: 'Total Days Absent',
  timesLate: 'Times Late',
  totalTimesLate: 'Total Times Late',
  frenchProgram: 'French Program',
  teacher: 'Teacher',
  earlyChildhoodEducator: 'Early Childhood Educator',
  principal: 'Principal',
  telephone: 'Telephone',
  board: 'School Board',
  school: 'School',
  schoolAddress: 'School Address',
  boardAddress: 'Board Address',
  placement: 'Placement in September',
  belongingEsl: 'Belonging - ESL',
  belongingIep: 'Belonging - IEP',
  belongingComments: 'Belonging and Contributing - Key Learning / Growth / Next Steps',
  selfRegulationEsl: 'Self-Regulation - ESL',
  selfRegulationIep: 'Self-Regulation - IEP',
  selfRegulationComments: 'Self-Regulation and Well-Being - Key Learning / Growth / Next Steps',
  literacyMathEsl: 'Literacy & Math - ESL',
  literacyMathIep: 'Literacy & Math - IEP',
  literacyMathComments: 'Demonstrating Literacy and Mathematics Behaviours - Key Learning / Growth / Next Steps',
  problemSolvingEsl: 'Problem Solving - ESL',
  problemSolvingIep: 'Problem Solving - IEP',
  problemSolvingComments: 'Problem Solving and Innovating - Key Learning / Growth / Next Steps',
  ersCompleted: 'Early Reading Screening (Year 2) - Completed',
  ersDateYear: 'ERS Date - Year',
  ersDateMonth: 'ERS Date - Month',
  ersDateDay: 'ERS Date - Day',
  ersBenchmarkMet: 'Early Reading Screening - Benchmark Met',
  eceNames: 'Early Childhood Educator Names (signature line)',
}
